export default "__VITE_ASSET__BC6KKCP3__"